// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file internalapi/v1/contract.proto (package internalapi.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { AreaMapping, BankAccount, EclearFeePattern, OrganizationContract, OrganizationOption, PhysicalContractDeliveryType, ReceivingPaymentBankAccount } from "./contract_model_pb";
import { file_internalapi_v1_contract_model } from "./contract_model_pb";
import type { DatePeriod } from "../../types/v1/date_pb";
import { file_types_v1_date } from "../../types/v1/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file internalapi/v1/contract.proto.
 */
export const file_internalapi_v1_contract: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_internalapi_v1_contract_model, file_types_v1_date]);

/**
 * @generated from message internalapi.v1.GetOrganizationContractRequest
 */
export type GetOrganizationContractRequest = Message<"internalapi.v1.GetOrganizationContractRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message internalapi.v1.GetOrganizationContractRequest.
 * Use `create(GetOrganizationContractRequestSchema)` to create a new message.
 */
export const GetOrganizationContractRequestSchema: GenMessage<GetOrganizationContractRequest> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract, 0);

/**
 * @generated from message internalapi.v1.GetOrganizationContractResponse
 */
export type GetOrganizationContractResponse = Message<"internalapi.v1.GetOrganizationContractResponse"> & {
  /**
   * @generated from field: internalapi.v1.OrganizationContract organization_contract = 1;
   */
  organizationContract?: OrganizationContract;
};

/**
 * Describes the message internalapi.v1.GetOrganizationContractResponse.
 * Use `create(GetOrganizationContractResponseSchema)` to create a new message.
 */
export const GetOrganizationContractResponseSchema: GenMessage<GetOrganizationContractResponse> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract, 1);

/**
 * @generated from message internalapi.v1.ListOrganizationContractsRequest
 */
export type ListOrganizationContractsRequest = Message<"internalapi.v1.ListOrganizationContractsRequest"> & {
  /**
   * @generated from field: repeated string organization_ids = 1;
   */
  organizationIds: string[];
};

/**
 * Describes the message internalapi.v1.ListOrganizationContractsRequest.
 * Use `create(ListOrganizationContractsRequestSchema)` to create a new message.
 */
export const ListOrganizationContractsRequestSchema: GenMessage<ListOrganizationContractsRequest> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract, 2);

/**
 * @generated from message internalapi.v1.ListOrganizationContractsResponse
 */
export type ListOrganizationContractsResponse = Message<"internalapi.v1.ListOrganizationContractsResponse"> & {
  /**
   * @generated from field: repeated internalapi.v1.OrganizationContract organization_contracts = 1;
   */
  organizationContracts: OrganizationContract[];
};

/**
 * Describes the message internalapi.v1.ListOrganizationContractsResponse.
 * Use `create(ListOrganizationContractsResponseSchema)` to create a new message.
 */
export const ListOrganizationContractsResponseSchema: GenMessage<ListOrganizationContractsResponse> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract, 3);

/**
 * @generated from message internalapi.v1.CreateOrganizationContractRequest
 */
export type CreateOrganizationContractRequest = Message<"internalapi.v1.CreateOrganizationContractRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: internalapi.v1.PhysicalContractDeliveryType physical_contract_delivery_type = 2;
   */
  physicalContractDeliveryType: PhysicalContractDeliveryType;

  /**
   * @generated from field: repeated types.v1.DatePeriod payment_timings = 3;
   */
  paymentTimings: DatePeriod[];

  /**
   * @generated from field: internalapi.v1.EclearFeePattern eclear_fee_pattern = 4;
   */
  eclearFeePattern?: EclearFeePattern;

  /**
   * @generated from field: optional internalapi.v1.BankAccount payment_account = 5;
   */
  paymentAccount?: BankAccount;

  /**
   * @generated from field: internalapi.v1.ReceivingPaymentBankAccount receiving_payment_account = 6;
   */
  receivingPaymentAccount?: ReceivingPaymentBankAccount;

  /**
   * @generated from field: internalapi.v1.OrganizationOption organization_option = 7;
   */
  organizationOption?: OrganizationOption;

  /**
   * 読み替えを持たない組織が通常なので、空で正常。重複は app 側の
   * OrganizationContract.Validate() と DB の一意制約で弾く。
   *
   * @generated from field: repeated internalapi.v1.AreaMapping area_mappings = 8;
   */
  areaMappings: AreaMapping[];
};

/**
 * Describes the message internalapi.v1.CreateOrganizationContractRequest.
 * Use `create(CreateOrganizationContractRequestSchema)` to create a new message.
 */
export const CreateOrganizationContractRequestSchema: GenMessage<CreateOrganizationContractRequest> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract, 4);

/**
 * @generated from message internalapi.v1.CreateOrganizationContractResponse
 */
export type CreateOrganizationContractResponse = Message<"internalapi.v1.CreateOrganizationContractResponse"> & {
};

/**
 * Describes the message internalapi.v1.CreateOrganizationContractResponse.
 * Use `create(CreateOrganizationContractResponseSchema)` to create a new message.
 */
export const CreateOrganizationContractResponseSchema: GenMessage<CreateOrganizationContractResponse> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract, 5);

/**
 * @generated from message internalapi.v1.UpdateOrganizationContractRequest
 */
export type UpdateOrganizationContractRequest = Message<"internalapi.v1.UpdateOrganizationContractRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: internalapi.v1.PhysicalContractDeliveryType physical_contract_delivery_type = 2;
   */
  physicalContractDeliveryType: PhysicalContractDeliveryType;

  /**
   * @generated from field: repeated types.v1.DatePeriod payment_timings = 3;
   */
  paymentTimings: DatePeriod[];

  /**
   * @generated from field: internalapi.v1.EclearFeePattern eclear_fee_pattern = 4;
   */
  eclearFeePattern?: EclearFeePattern;

  /**
   * @generated from field: optional internalapi.v1.BankAccount payment_account = 5;
   */
  paymentAccount?: BankAccount;

  /**
   * @generated from field: internalapi.v1.ReceivingPaymentBankAccount receiving_payment_account = 6;
   */
  receivingPaymentAccount?: ReceivingPaymentBankAccount;

  /**
   * @generated from field: internalapi.v1.OrganizationOption organization_option = 7;
   */
  organizationOption?: OrganizationOption;

  /**
   * 読み替えを持たない組織が通常なので、空で正常。重複は app 側の
   * OrganizationContract.Validate() と DB の一意制約で弾く。
   *
   * @generated from field: repeated internalapi.v1.AreaMapping area_mappings = 8;
   */
  areaMappings: AreaMapping[];
};

/**
 * Describes the message internalapi.v1.UpdateOrganizationContractRequest.
 * Use `create(UpdateOrganizationContractRequestSchema)` to create a new message.
 */
export const UpdateOrganizationContractRequestSchema: GenMessage<UpdateOrganizationContractRequest> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract, 6);

/**
 * @generated from message internalapi.v1.UpdateOrganizationContractResponse
 */
export type UpdateOrganizationContractResponse = Message<"internalapi.v1.UpdateOrganizationContractResponse"> & {
};

/**
 * Describes the message internalapi.v1.UpdateOrganizationContractResponse.
 * Use `create(UpdateOrganizationContractResponseSchema)` to create a new message.
 */
export const UpdateOrganizationContractResponseSchema: GenMessage<UpdateOrganizationContractResponse> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract, 7);

/**
 * @generated from service internalapi.v1.ContractService
 */
export const ContractService: GenService<{
  /**
   * @generated from rpc internalapi.v1.ContractService.GetOrganizationContract
   */
  getOrganizationContract: {
    methodKind: "unary";
    input: typeof GetOrganizationContractRequestSchema;
    output: typeof GetOrganizationContractResponseSchema;
  },
  /**
   * @generated from rpc internalapi.v1.ContractService.ListOrganizationContracts
   */
  listOrganizationContracts: {
    methodKind: "unary";
    input: typeof ListOrganizationContractsRequestSchema;
    output: typeof ListOrganizationContractsResponseSchema;
  },
  /**
   * @generated from rpc internalapi.v1.ContractService.CreateOrganizationContract
   */
  createOrganizationContract: {
    methodKind: "unary";
    input: typeof CreateOrganizationContractRequestSchema;
    output: typeof CreateOrganizationContractResponseSchema;
  },
  /**
   * @generated from rpc internalapi.v1.ContractService.UpdateOrganizationContract
   */
  updateOrganizationContract: {
    methodKind: "unary";
    input: typeof UpdateOrganizationContractRequestSchema;
    output: typeof UpdateOrganizationContractResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_internalapi_v1_contract, 0);

